import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoHeaderComponent } from './logo-header.component';

@NgModule({
  declarations: [LogoHeaderComponent],
  imports: [CommonModule],
  exports: [LogoHeaderComponent]
})
export class LogoHeaderModule {}
